import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { cn } from "@/lib/utils";
import type { OkrCycle } from "@/types";
import type { CyclePacing } from "./okr-overview";

const VERDICT_CONFIG = {
  "on-track": { label: "On track", icon: Minus, className: "bg-blue-500/10 text-blue-500" },
  behind: { label: "Behind", icon: TrendingDown, className: "bg-destructive/10 text-destructive" },
  ahead: { label: "Ahead", icon: TrendingUp, className: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400" },
} as const;

interface OkrPacingCardProps {
  cycle: OkrCycle;
  pacing: CyclePacing;
}

/** Cycle pacing strip: day-in-cycle, time elapsed vs. average progress of active objectives, verdict pill. */
export function OkrPacingCard({ cycle, pacing }: OkrPacingCardProps) {
  const verdict = VERDICT_CONFIG[pacing.verdict];
  const VerdictIcon = verdict.icon;

  return (
    <div className="mb-6 flex flex-wrap items-center gap-x-6 gap-y-2 rounded-xl border border-border bg-card px-5 py-4">
      <div className="text-sm font-medium">
        {cycle.name || `Q${cycle.quarter} ${cycle.year}`}
        <span className="ml-2 text-muted-foreground font-normal">
          Day {pacing.dayOfCycle} of {pacing.totalDays}
        </span>
      </div>
      <div className="text-sm text-muted-foreground">
        Time elapsed <span className="font-semibold text-foreground">{pacing.elapsedPct}%</span>
      </div>
      <div className="text-sm text-muted-foreground">
        Progress <span className="font-semibold text-foreground">{pacing.progressPct}%</span>
      </div>
      <span className={cn("inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold", verdict.className)}>
        <VerdictIcon className="h-3.5 w-3.5" /> {verdict.label}
      </span>
    </div>
  );
}
